import React, { useState, useEffect, useRef } from "react";
import {
  fetchAllFeedbacksData,
  formatDataForTableRows,
  getFeedbackDataFromId,
  putFeedbackAssignRequestData,
  putFeedbackViewRequestData,
} from "../../../features/manageFeedbacks/manageFeedbacksService";
import DefaultHeading from "../../heading/DefaultHeading";
import "./feedbacksContainer.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel } from "@fortawesome/free-solid-svg-icons";
import { Loader } from "../../loader/Loader";
import FeedbacksTable from "../FeedbacksTable/FeedbacksTable";
import FeedbackAssignModal from "../FeedbackAssignModal/FeedbackAssignModal";
import FeedbackViewModal from "../FeedbackViewModal/FeedbackViewModal";
import { Dayjs } from "dayjs";
import {
  Assignee,
  AssignSubmitRequestData,
  ViewSubmitRequestData,
} from "../../../features/manageFeedbacks/manageFeedbacksTypes";
import { ConfirmationPopUp } from "../../popup/confirmationPopUp";
import DownloadLoader from "../../popup/downloadLoader";
import { GenericPopUp } from "../../popup/genericPopUp";
import {
  uploadReport,
  getReportStatus,
  downloadSupportReport,
} from "../../../services/supportService";
import { popupType } from "../../../types/types";
interface FeedbacksContainerProps {
  dateFilter: Record<string, Dayjs>;
  typeAndStatusFilter: Record<string, string>;
  allFeedbacksData: Record<string, any>[];
  brandsData: string[];
  flavoursData: string[];
  fetchUpdatedData: () => void;
  manufacturingLocations: string[];
  supportAssignees: Assignee[];
}

const FeedbacksContainer: React.FC<FeedbacksContainerProps> = ({
  dateFilter,
  typeAndStatusFilter,
  allFeedbacksData,
  brandsData,
  flavoursData,
  fetchUpdatedData,
  manufacturingLocations,
  supportAssignees,
}) => {
  const [data, setData] = useState<Record<string, any>[]>(allFeedbacksData);
  const [loading, setLoading] = useState<boolean>(false);
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [FeedbackAssignModalOpen, setFeedbackAssignModalOpen] = useState(false);
  const [FeedbackViewModalOpen, setFeedbackViewModalOpen] = useState(false);
  const [selectedFeedbackId, setSelectedFeedbackId] = useState<string>("");
  const [isInitialMount, setIsInitialMount] = useState(true);
  const [confirmationPopUp, setConfirmationPopUp] = useState(false);
  const [popUpMessage, setPopUpMessage] = useState<string>("");
  const [reportDownloadInProcess, setReportDownloadInProcess] = useState(false);
  const [openReportModel, setOpenReportModal] = useState(false);
  const [genericModalMessage, setGenericModalSMessage] = useState("");
  const [genericModalState, setGenericModalState] = useState(false);
  const [genericModaltype, setGenericModalType] = useState<popupType>("Error");

  const popUpSuccessMethod = useRef<any>();
  const handleAssignClick = (id: string) => {
    setSelectedFeedbackId(id); // Save the selected feedback ID to pass to the modal
    setFeedbackAssignModalOpen(true); // Open the Assign modal
  };

  const handleViewClick = (id: string) => {
    setSelectedFeedbackId(id); // Save the selected feedback ID to pass to the modal
    setFeedbackViewModalOpen(true); // Open the View modal
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value);
  };
  //TODO : open a popup for failed and successful submission
  const handleAssignSubmitRequest = async (data: AssignSubmitRequestData) => {
    try {
      // Call the PUT API to submit the data
      const response = await putFeedbackAssignRequestData(data);

      // Check if submission is successful
      if (response?.status === 200) {
        fetchUpdatedData(); // Call to fetch updated data after submission
      } else {
        openPopUp("Failed to submit request", "Error");
        console.error("Failed to submit assign request:", response.statusText);
      }
    } catch (error) {
      openPopUp("Failed to submit request", "Error");
      console.error("Error during assign submit request:", error);
    }
  };
  //TODO : open a popup for failed and successful submission
  const handleViewSubmitRequest = async (data: ViewSubmitRequestData) => {

    try {
      // Call the PUT API to submit the data
      const response = await putFeedbackViewRequestData(data);
      // Check if submission is successful
      if (response?.status === 200) {
        console.log("View request submitted successfully");
        fetchUpdatedData(); // Call to fetch updated data after submission
      } else {
        openPopUp("Failed to submit request", "Error");
        console.error("Failed to submit view request:", response.statusText);
      }
    } catch (error) {
      openPopUp("Failed to submit request", "Error");
      console.error("Error during view submit request:", error);
    }
  };
  const createRequestBodyForReport = () => {
    const authContext = JSON.parse(localStorage.getItem("authContext") || "{}"); // Ensure authContext exists

    const requestBody = {
      attributes: {
        name: "HelpdeskReportExcel",
        format: "xlsx",
        fromDate: dateFilter.fromDate
          ? dateFilter.fromDate.format("YYYY-MM-DD HH:mm:ss")
          : "",
        toDate: dateFilter.toDate
          ? dateFilter.toDate.format("YYYY-MM-DD HH:mm:ss")
          : "",
      },
      lob: authContext.user?.lob || "",
    };

    const dataObj = JSON.stringify(requestBody);
    generateReport(dataObj);
  };
  const openPopUp = (message: string, modalType: popupType) => {
    setGenericModalSMessage(message);
    setGenericModalState(true);
    setGenericModalType(modalType);
  };
  const generateReport = async (obj: string) => {
    const requestBody = JSON.parse(obj);
    if (reportDownloadInProcess) {
      //TODO : Translate
      openPopUp("Report downloading already in progress,please wait.", "Alert");
      return;
    }
    setReportDownloadInProcess(true);
    setOpenReportModal(true);
    const response = await uploadReport(requestBody);
    checkReportStatus(response.data.id);
  };
  const checkReportStatus = async (id: string) => {
    const response = await getReportStatus(id);
    if (response.status === 200 && response.data.features.length > 0) {
      const reportMetaData = response.data.features[0];
      const status = reportMetaData.status;
      if (status === "SUCCESS" || status === "FAILURE") {
        await downloadReport(id);
        setReportDownloadInProcess(false);
        if (status === "FAILURE") {
          setOpenReportModal(false);
          //TODO : Translate
          openPopUp("Something Went Wrong", "Error");
        }
      } else {
        setTimeout(() => {
          checkReportStatus(id);
        }, 10000);
      }
    } else {
      //TODO : Translate
      openPopUp(
        "Looks like master data report has not been generated yet",
        "Alert"
      );
    }
  };
  const downloadReport = async (id: string) => {
    try {
      const response = await downloadSupportReport(id);
      if (response.status === 200) {
        const disposition = response.headers["content-disposition"];

        let filename = "";
        if (disposition && disposition.indexOf("attachment") !== -1) {
          const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          const matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, "");
          }
          const blob = new Blob([response.data], {
            type: "application/octet-stream",
          }) as Blob;
          const URL = window.URL || window.webkitURL;
          const downloadUrl = URL.createObjectURL(blob);
          const a = document.createElement("a");
          if (typeof a.download === "undefined") {
            //TODO : Translate
            openPopUp("Error while downloading file", "Alert");
          } else {
            a.href = downloadUrl;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          }
        } else if (
          disposition &&
          disposition.indexOf("File is too big to download") !== -1
        ) {
          //TODO : Translate
          openPopUp("Error while downloading file", "Alert");
        } else {
          //TODO : Translate
          openPopUp("Error while downloading file", "Alert");
        }
      } else {
        //TODO : Translate
        openPopUp("Error while downloading file", "Alert");
      }

      setReportDownloadInProcess(false);
      setOpenReportModal(false);
    } catch (error) {
      //TODO : Translate
      openPopUp("Error while downloading file", "Alert");
      setReportDownloadInProcess(false);
      setOpenReportModal(false);
    }
  };

  const updateConfirmationPopData = (message: string, methodHelper: any) => {
    popUpSuccessMethod.current = methodHelper;
    setPopUpMessage(message);
  };
  useEffect(() => {
    if (isInitialMount) {
      setIsInitialMount(false);
      return; // Skip the first render
    }
    const fetchFeedbacksData = async () => {
      setLoading(true); // Start loading
      const errors : string[]= []; // Array to collect error messages
  
      try {
          // Execute the fetch call
          const results = await Promise.allSettled([
              fetchAllFeedbacksData(dateFilter), // Your current fetch call
              // Add more API calls if needed
          ]);
  
          // Process results
          results.forEach((result, index) => {
              if (result.status === 'fulfilled') {
                  // Assign the successfully fetched data to state
                  setData(result.value);
              } else {
                  // Handle the error for this specific API call
                  console.error(`API call ${index + 1} failed with reason:`, result.reason);
                  //TODO : Translate
                  errors.push("Fetching Feedbacks Data");
              }
          });
  
          // Show popup if there were any errors
          if (errors.length > 0) {
            //TODO : Translate
              openPopUp(`Errors in fetching data for: ${errors.join(", ")}`, "Error");
          }
  
      } catch (error) {
          console.error("Unexpected error occurred:", error);
          //TODO : Translate
          openPopUp("Something Went Wrong", "Error");
      } finally {
          setLoading(false); // Stop loading regardless of the outcome
      }
  };
    if (dateFilter.fromDate && dateFilter.toDate) {
      fetchFeedbacksData(); // Call the async function
    }
  }, [dateFilter]);
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className="feedbacksContainer-wrapper">
          <div className="feedbacksContainer-heading-wrapper">
            {/* //TODO : Translate */}
            <DefaultHeading heading={"Manage Feedbacks"} />
            <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
              <div className="feedbacksContainer-searchQuery">
                {/*  //TODO : Translate */}
                <span>Search:</span>
                <input
                  type="text"
                  //TODO : Translate
                  placeholder="Search"
                  value={searchQuery} // Bind searchQuery to input value
                  onChange={handleSearchChange} // Update state on change
                />
              </div>
              <FontAwesomeIcon
                className="manageFeedbacks-downloadIcon"
                icon={faFileExcel}
                onClick={() => {
                  setConfirmationPopUp(true);
                  updateConfirmationPopData(
                    //TODO : Translate
                    "Are you sure want to export the report?",
                    createRequestBodyForReport
                  );
                }}
              />
            </div>
          </div>
          <div className="feedbacksContainer-table">
            <FeedbacksTable
              data={formatDataForTableRows(data, supportAssignees)}
              typeAndStatusFilter={typeAndStatusFilter}
              searchQuery={searchQuery}
              onAssignClick={handleAssignClick} // Pass the function to the table
              onViewClick={handleViewClick} // Pass the function to the table
            />
          </div>
        </div>
      )}
      {/* Modal for Assign Feedback */}
      {FeedbackAssignModalOpen && (
        <FeedbackAssignModal
          open={FeedbackAssignModalOpen}
          onClose={() => setFeedbackAssignModalOpen(false)}
          feedbackData={getFeedbackDataFromId(data, selectedFeedbackId)}
          onConfirm={handleAssignSubmitRequest}
          supportAssignees={supportAssignees}
        />
      )}

      {/* Modal for View Feedback */}
      {FeedbackViewModalOpen && (
        <FeedbackViewModal
          brandsData={brandsData}
          flavoursData={flavoursData}
          open={FeedbackViewModalOpen}
          onClose={() => setFeedbackViewModalOpen(false)}
          feedbackData={getFeedbackDataFromId(data, selectedFeedbackId)}
          onConfirm={handleViewSubmitRequest}
          manufacturingLocations={manufacturingLocations}
          supportAssignees={supportAssignees}
        />
      )}
      <GenericPopUp
        type={genericModaltype}
        message={genericModalMessage}
        openGenericModal={genericModalState}
        setOpenGenericModal={() => {
          setGenericModalState(false);
        }}
      />
      <ConfirmationPopUp
        openConfirmModal={confirmationPopUp}
        message={popUpMessage}
        setOpenConfirmModal={() => {
          setConfirmationPopUp(false);
        }}
        successMethod={popUpSuccessMethod.current}
      />
      {openReportModel ? (
        <DownloadLoader
          //TODO : Translate
          message={"Your report will be downloaded shortly."}
          openReportModal={openReportModel}
          setOpenReportModal={setOpenReportModal}
        />
      ) : null}
    </>
  );
};

export default FeedbacksContainer;
